<div class="step-layout !mx-auto !flex !w-full !flex-col !gap-8">
    <header class="!flex !flex-col !gap-2">
        <p class="!mb-0 !text-xs !font-bold !uppercase !tracking-[0.08em] !text-primary">
            Passo 1 di 8
        </p>
        <h2 class="!mb-0 !text-[clamp(1.75rem,3vw,2.25rem)] !font-extrabold !leading-tight !text-strong">
            Crea l'account del <span class="gradient-text">manager</span>
        </h2>
        <p class="!mb-0 !max-w-xl !text-base !leading-relaxed !text-subtle">
            Scegli le credenziali che il manager userà per accedere alla società e riprendere l'onboarding.
        </p>
    </header>

    <form #accountForm="ngForm" class="!flex !flex-col !gap-7" (ngSubmit)="tryContinue(accountForm)">
        <section class="!rounded-2xl !border !border-border !bg-white !p-6 md:!p-8"
                 aria-labelledby="manager-credentials-title">
            <div class="!mb-5 !border-b !border-slate-100 !pb-3">
                <h3 id="manager-credentials-title" class="!mb-1 !text-base !font-bold !text-strong">
                    Credenziali di accesso
                </h3>
                <p class="!mb-0 !text-sm !leading-snug !text-subtle">
                    Usa un indirizzo email controllato dal manager e una password sicura.
                </p>
            </div>

            <div class="!grid !grid-cols-1 !gap-x-5 !gap-y-5 md:!grid-cols-2">
                <div class="!min-w-0">
                    <label for="company-manager-email"
                           class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">
                        Email del manager
                    </label>
                    <input
                        type="email"
                        class="form-control !min-h-11 !rounded-xl !border-slate-200 focus:!border-primary focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                        id="company-manager-email"
                        name="managerEmail"
                        required
                        email
                        maxlength="50"
                        autocomplete="email"
                        placeholder="manager@azienda.it"
                        [(ngModel)]="company.legalEmail"
                        #managerEmail="ngModel"
                        (ngModelChange)="persistForm()"
                        [class.is-invalid]="managerEmail.invalid && (managerEmail.dirty || managerEmail.touched || submitted)"
                    />
                    <p class="!mb-0 !mt-1.5 !text-xs !leading-snug !text-slate-400"
                       *ngIf="!managerEmail.invalid || (!managerEmail.dirty && !managerEmail.touched && !submitted)">
                        Verrà usata anche per le comunicazioni relative all'account.
                    </p>
                    <p class="!mb-0 !mt-1.5 !text-sm !text-red-600"
                       *ngIf="managerEmail.invalid && (managerEmail.dirty || managerEmail.touched || submitted)">
                        Inserisci un indirizzo email valido.
                    </p>
                </div>

                <div class="!min-w-0">
                    <label for="company-manager-password"
                           class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">
                        Password
                    </label>
                    <div class="!relative">
                        <input
                            class="form-control !min-h-11 !rounded-xl !border-slate-200 !pr-12 focus:!border-primary focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                            id="company-manager-password"
                            name="managerPassword"
                            required
                            maxlength="255"
                            autocomplete="new-password"
                            [type]="showPassword ? 'text' : 'password'"
                            [(ngModel)]="company.legalPassword"
                            #managerPassword="ngModel"
                            (ngModelChange)="persistForm()"
                            [class.is-invalid]="!isPasswordValid() && (managerPassword.dirty || managerPassword.touched || submitted)"
                        />
                        <button
                            class="!absolute !right-1.5 !top-1/2 !inline-flex !h-8 !w-8 !-translate-y-1/2 !items-center !justify-center !rounded-lg !border-0 !bg-transparent !text-slate-400 hover:!bg-slate-100 hover:!text-slate-700 focus-visible:!outline-none focus-visible:!ring-2 focus-visible:!ring-primary"
                            type="button"
                            (click)="togglePasswordVisibility()"
                            [attr.aria-label]="showPassword ? 'Nascondi password' : 'Mostra password'">
                            <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                        </button>
                    </div>
                    <p class="!mb-0 !mt-1.5 !text-sm !text-red-600"
                       *ngIf="!isPasswordValid() && (managerPassword.dirty || managerPassword.touched || submitted)">
                        La password non soddisfa ancora tutti i requisiti.
                    </p>
                </div>

                <div class="!rounded-xl !border !border-slate-100 !bg-slate-50 !p-4 md:!col-span-2">
                    <p class="!mb-3 !text-sm !font-semibold !text-slate-600">La password deve contenere:</p>
                    <ul class="!m-0 !grid !list-none !grid-cols-1 !gap-x-5 !gap-y-2 !p-0 sm:!grid-cols-2">
                        <li class="!flex !items-center !gap-2 !text-sm"
                            [ngClass]="passwordHasMinimumLength ? '!text-primary' : '!text-slate-400'">
                            <i class="bi" [ngClass]="passwordHasMinimumLength ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                            Almeno 8 caratteri
                        </li>
                        <li class="!flex !items-center !gap-2 !text-sm"
                            [ngClass]="passwordHasUpperAndLowerCase ? '!text-primary' : '!text-slate-400'">
                            <i class="bi" [ngClass]="passwordHasUpperAndLowerCase ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                            Una maiuscola e una minuscola
                        </li>
                        <li class="!flex !items-center !gap-2 !text-sm"
                            [ngClass]="passwordHasNumber ? '!text-primary' : '!text-slate-400'">
                            <i class="bi" [ngClass]="passwordHasNumber ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                            Almeno un numero
                        </li>
                        <li class="!flex !items-center !gap-2 !text-sm"
                            [ngClass]="passwordHasSpecialCharacter ? '!text-primary' : '!text-slate-400'">
                            <i class="bi" [ngClass]="passwordHasSpecialCharacter ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                            Un carattere speciale
                        </li>
                    </ul>
                </div>
            </div>
        </section>

        <div class="step-actions">
            <button type="button" class="btn-back" (click)="!isProcessing && previousStep()"
                    [class.btn-back--disabled]="isProcessing">
                Indietro
            </button>
            <div class="step-actions-end">
                <p class="!mb-0 !w-full !text-right !text-sm !text-red-700"
                   *ngIf="submitted && (accountForm.invalid || !isPasswordValid())">
                    Inserisci un'email valida e completa tutti i requisiti della password.
                </p>
                <button class="btn-procedi" type="submit" [disabled]="isProcessing">
                    <span *ngIf="isProcessing" class="spinner-border spinner-border-sm me-2" role="status"></span>
                    {{ isProcessing ? 'Creazione account...' : 'Crea account e procedi' }}
                </button>
            </div>
        </div>
    </form>
</div>
